import { containerOne, tableData, tableHeader, title } from '../utils/style';
import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { url } from '../utils/config';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useRecoilState } from 'recoil';
import loaderStateAtom from '../atoms/loaderStateAtom';
import uiConfigAtom from '../atoms/uiConfigAtom';
import backButton from "../assets/backButton.png";
import { useNavigate } from 'react-router-dom';
import navHeaderAtom from '../atoms/navHeaderAtom';
import TrainingCard from '../reusable_components/TrainingCard';
import certification from '../assets/icons/certification.png';
import CertificationCard from '../reusable_components/CertificationCard';

function Trainings() {
    // const [ trainings, setTrainings ] = useState([]);
    const [ showLoader, setShowLoader ] = useRecoilState(loaderStateAtom)
    const [ uiConfig ] = useRecoilState(uiConfigAtom);
    const [ header, setHeader ] = useRecoilState(navHeaderAtom)
    const [ status, setStatus ] = useState('Ongoing')
    let navigate = useNavigate();

    useEffect(() => {
        setHeader('Trainings')
    }, [])

    const style = {
        backgroundColor: uiConfig?.table?.headerColor?.hex,
        color: uiConfig?.table?.fontColor?.hex
    }

    const boardTrainings = [
        {
            id: 1,
            image: certification,
            title: 'On-Board 1',
            lessons: '30',
            duration: '8h 30min'
        },
        {
            id: 2,
            image: certification,
            title: 'On-Board 1',
            lessons: '30',
            duration: '8h 30min'
        },
        {
            id: 3,
            image: certification,
            title: 'On-Board 1',
            lessons: '30',
            duration: '8h 30min'
        }
    ]

    const trainings = [
        {
            id: 1,
            image: certification,
            title: 'On-Board 1',
            lessons: '30',
            duration: '8h 30min',
            date: '10/08/2024',
            completed: 20
        },
        {
            id: 2,
            image: certification,
            title: 'On-Board 1',
            lessons: '30',
            duration: '8h 30min',
            date: '10/08/2024',
            completed: 20
        },
        {
            id: 3,
            image: certification,
            title: 'On-Board 1',
            lessons: '30',
            duration: '8h 30min',
            date: '10/08/2024',
            completed: 40
        }
    ]

    async function getTrainings() {
        try {
            setShowLoader(true)
            const reqUrl = url + '/trainings';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const {data} = await axios.get(reqUrl, { headers });
            console.log(data.data);
            //set data in state
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    async function requestTraining(id) {
        try {
            setShowLoader(true)
            console.log(id)
            // const reqUrl = url + '/training_request/' + certificationId;
            // const token = window.localStorage.getItem('token');
            // const headers = { authorization: `bearer ${token}` };
            // const data = await axios.get(reqUrl, { headers });
            // console.log(data.data);
            //set data in state
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }

    return(
        <div className={containerOne}>
            <div className={title}>On-Board Trainings</div>
            <div className='flex gap-4 overflow-x-scroll scroll-x-auto flex-nowrap py-4'>
                {
                    boardTrainings.map(t => 
                        <TrainingCard 
                            id={t.id} 
                            image={t.image}
                            title={t.title}
                            lessons={t.lessons}
                            duration={t.duration}
                            requestTraining={requestTraining}
                        />
                    )
                }
            </div>
            <div className='flex justify-between items-center py-2'>
                <div className={title}>Trainings</div>
                <Link className=' font-semibold text-sm text-customOne' to='/certifications'>{`Advanced Training/Certification >`}</Link>
            </div>
            <div className="flex text-sm text-customOne font-semibold border-2 border-customOne rounded-full p-1 my-2">
                <div className={`flex-1 px-4 py-2 text-center ${status === 'Requested' && 'text-white bg-customOne rounded-full'}`} onClick={() => setStatus('Requested')}>Requested</div>
                <div className={`flex-1 px-4 py-2 text-center ${status === 'Ongoing' && 'text-white bg-customOne rounded-full'}`} onClick={() => setStatus('Ongoing')}>Ongoing</div>
                <div className={`flex-1 px-4 py-2 text-center ${status === 'Completed' && 'text-white bg-customOne rounded-full'}`} onClick={() => setStatus('Completed')}>Completed</div>
            </div>
            <div>
                {
                    trainings.map(tr => 
                        <CertificationCard 
                            id={tr.id} 
                            image={tr.image} 
                            title={tr.title}
                            lessons={tr.lessons}
                            duration={tr.duration}
                            date={tr.date}
                            completed={tr.completed}
                        />
                    )
                }
            </div>
        </div>
    )
}

export default Trainings;